(() => {
  const mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const CLOSE_DELAY = 120;

  function setExpanded(item, expanded) {
    const trigger = item.querySelector(':scope > [data-jersey-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeItem(item) {
    if (!item) return;
    item.classList.remove('is-open');
    setExpanded(item, false);
  }

  function closeOthers(current) {
    document.querySelectorAll('[data-jersey-nav-item].is-open').forEach((item) => {
      if (item !== current) closeItem(item);
    });
  }

  function openItem(item) {
    if (!item || item.hidden) return;
    closeOthers(item);
    item.classList.add('is-open');
    setExpanded(item, true);
  }

  function initNav(root = document) {
    root.querySelectorAll('[data-jersey-nav-item]').forEach((item) => {
      if (item.hidden || item.dataset.jerseyBound === 'true') return;
      item.dataset.jerseyBound = 'true';

      const trigger = item.querySelector(':scope > [data-jersey-nav-trigger]');
      const panel = item.querySelector(':scope > [data-jersey-panel]');
      if (!trigger || !panel || panel.hidden) return;

      let timer;

      item.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        openItem(item);
      });

      item.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => closeItem(item), CLOSE_DELAY);
      });

      item.addEventListener('focusin', () => {
        clearTimeout(timer);
        openItem(item);
      });

      item.addEventListener('focusout', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!item.contains(document.activeElement)) closeItem(item);
        }, 0);
      });

      trigger.addEventListener('click', (event) => {
        if (trigger.tagName === 'BUTTON') {
          event.preventDefault();
          item.classList.contains('is-open') ? closeItem(item) : openItem(item);
          return;
        }

        if (!mq.matches && window.innerWidth >= 990) {
          event.preventDefault();
          item.classList.contains('is-open') ? closeItem(item) : openItem(item);
        }
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeItem(item);
        trigger.focus();
      });
    });
  }

  function initLocale(root = document) {
    root.querySelectorAll('[data-jersey-locale]').forEach((details) => {
      if (details.dataset.jerseyLocaleBound === 'true') return;
      details.dataset.jerseyLocaleBound = 'true';

      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll('[data-jersey-locale][open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });
  }

  function normalizeLabel(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function labelForLink(link) {
    if (!link) return '';
    const clone = link.cloneNode(true);
    clone.querySelectorAll('svg, .jersey-unmatched-badge').forEach((node) => node.remove());
    return normalizeLabel(clone.textContent);
  }

  function isUnmatchedLink(link) {
    if (!link) return false;
    const href = link.getAttribute('href') || '';
    return href === '#jersey-unmatched' || href.includes('jersey_unmatched=1');
  }

  function compileHiddenPatterns(raw) {
    if (!raw) return [];
    return String(raw)
      .split(/[\n,;]+/)
      .map((value) => normalizeLabel(value))
      .filter(Boolean)
      .map((pattern) => {
        const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*');
        return new RegExp(`^${escaped}$`, 'i');
      });
  }

  function matchesHiddenPattern(label, patterns) {
    return patterns.some((regex) => regex.test(label));
  }

  function directTopLink(item) {
    return item.querySelector(':scope > .jersey-nav__link, :scope > .jersey-nav__button');
  }

  function visibleChildren(parent, selector) {
    return Array.from(parent.querySelectorAll(selector)).filter((el) => !el.hidden);
  }

  function disableUnmatchedParentLink(link) {
    // Built-in top-level submenu parents (Club/Nation/Retro/Kids/Other Jersey)
    // are BUTTON triggers in V8. They are labels only and must never be
    // collection-matched, disabled, dimmed, or redirected.
    if (!link || link.tagName === 'BUTTON' || !isUnmatchedLink(link)) return;
    link.setAttribute('href', '#jersey-unmatched');
    link.setAttribute('aria-disabled', 'true');
    link.classList.add('jersey-menu-label--unmatched-parent');
  }

  function hideMatchedTarget(link) {
    if (!link) return;

    if (link.classList.contains('jersey-nav__link') || link.classList.contains('jersey-nav__button')) {
      const topItem = link.closest('.jersey-nav__item');
      if (topItem) topItem.hidden = true;
      return;
    }

    if (link.classList.contains('jersey-mega__heading')) {
      const column = link.closest('.jersey-mega__column');
      if (column) column.hidden = true;
      return;
    }

    const li = link.closest('li');
    if (li) li.hidden = true;
  }

  function manageReferenceMenu(container) {
    const nav = container.querySelector('[data-jersey-nav]');
    const configNode = container.querySelector('[data-jersey-menu-management]');
    if (!nav || !configNode || nav.dataset.jerseyManaged === 'true') return;

    let config;
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      console.warn('[Jersey header] Invalid menu-management JSON.', error);
      return;
    }

    if (!config.useReference) return;
    nav.dataset.jerseyManaged = 'true';

    const topVisibility = config.showTopLevel || {};
    const hiddenPatterns = compileHiddenPatterns(config.hiddenItems || '');

    // 1) Easy top-level switches from Theme Editor.
    nav.querySelectorAll(':scope .jersey-nav__list > .jersey-nav__item').forEach((item) => {
      const link = directTopLink(item);
      const label = labelForLink(link);
      if (Object.prototype.hasOwnProperty.call(topVisibility, label) && topVisibility[label] === false) {
        item.hidden = true;
      }
    });

    // 2) Explicit exclusions. One name per line, with optional * wildcards.
    if (hiddenPatterns.length) {
      nav.querySelectorAll('a, button').forEach((link) => {
        const label = labelForLink(link);
        if (!label || !matchesHiddenPattern(label, hiddenPatterns)) return;
        hideMatchedTarget(link);
      });
    }

    // 3) Automatically hide unmatched leaf items.
    if (config.hideUnmatched) {
      // Mega-menu leaf links.
      nav.querySelectorAll('.jersey-mega__link').forEach((link) => {
        if (!isUnmatchedLink(link)) return;
        const li = link.closest('li');
        if (li) li.hidden = true;
      });

      // Small-dropdown leaf links.
      nav.querySelectorAll('.jersey-dropdown__link').forEach((link) => {
        if (!isUnmatchedLink(link)) return;
        const li = link.closest('li');
        if (li) li.hidden = true;
      });

      // Standalone top-level links with no submenu.
      nav.querySelectorAll(':scope .jersey-nav__list > .jersey-nav__item').forEach((item) => {
        if (item.hidden) return;
        const panel = item.querySelector(':scope > [data-jersey-panel]');
        const link = directTopLink(item);
        if (!panel && isUnmatchedLink(link)) item.hidden = true;
      });
    }

    // 4) Clean columns after leaf filtering. Unmatched headings remain as labels
    //    when they still have matched children, so useful groups do not disappear.
    nav.querySelectorAll('.jersey-mega__column').forEach((column) => {
      if (column.hidden) return;
      const heading = column.querySelector(':scope > .jersey-mega__heading');
      const childList = column.querySelector(':scope > .jersey-mega__links');
      const visibleLeafItems = childList ? visibleChildren(childList, ':scope > li') : [];

      if (visibleLeafItems.length > 0) {
        disableUnmatchedParentLink(heading);
        return;
      }

      if (heading && isUnmatchedLink(heading)) {
        column.hidden = true;
      }
    });

    // 5) Remove empty panels / convert empty dropdowns into normal links.
    nav.querySelectorAll(':scope .jersey-nav__list > .jersey-nav__item').forEach((item) => {
      if (item.hidden) return;

      const mega = item.querySelector(':scope > .jersey-mega');
      if (mega) {
        const visibleColumns = visibleChildren(mega, '.jersey-mega__column');
        if (!visibleColumns.length) item.hidden = true;
        else disableUnmatchedParentLink(directTopLink(item));
        return;
      }

      const dropdown = item.querySelector(':scope > .jersey-dropdown');
      if (dropdown) {
        const list = dropdown.querySelector('.jersey-dropdown__list');
        const visibleItems = list ? visibleChildren(list, ':scope > li') : [];
        if (!visibleItems.length) {
          const trigger = directTopLink(item);
          if (trigger && trigger.tagName === 'A' && !isUnmatchedLink(trigger)) {
            dropdown.hidden = true;
            item.classList.remove('jersey-nav__item--has-children', 'jersey-nav__item--dropdown');
            trigger.removeAttribute('aria-haspopup');
            trigger.removeAttribute('aria-expanded');
            trigger.removeAttribute('data-jersey-nav-trigger');
            trigger.querySelector('.jersey-nav__caret')?.remove();
          } else {
            item.hidden = true;
          }
        } else {
          disableUnmatchedParentLink(directTopLink(item));
        }
      }
    });
  }

  function initSmartCollectionLinks(root = document) {
    const scope = root.matches && root.matches('.jersey-header-shell')
      ? root
      : root.querySelector && root.querySelector('.jersey-header-shell');

    const containers = [];
    if (scope) containers.push(scope);
    if (root === document) {
      document.querySelectorAll('.jersey-header-shell').forEach((el) => {
        if (!containers.includes(el)) containers.push(el);
      });
    }

    containers.forEach((container) => {
      container.querySelectorAll('a[href="#jersey-unmatched"]').forEach((link) => {
        if (link.dataset.jerseyUnmatchedBound === 'true') return;
        link.dataset.jerseyUnmatchedBound = 'true';
        link.setAttribute('aria-disabled', 'true');
        link.addEventListener('click', (event) => event.preventDefault());
      });

      if (!(window.Shopify && Shopify.designMode)) return;
      if (container.dataset.showUnmatchedBadges !== 'true') return;

      container.querySelectorAll('a:not([hidden])').forEach((link) => {
        if (link.closest('[hidden]')) return;
        const href = link.getAttribute('href') || '';
        const unmatched = href === '#jersey-unmatched' || href.includes('jersey_unmatched=1');
        if (!unmatched || link.dataset.jerseyUnmatchedMarked === 'true') return;

        link.dataset.jerseyUnmatchedMarked = 'true';
        link.title = '未匹配到当前店铺中的产品系列；当前使用回退链接。';

        const badge = document.createElement('span');
        badge.className = 'jersey-unmatched-badge';
        badge.textContent = '未匹配';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      });
    });
  }


  function mobileArrowSvg() {
    return '<svg class="jersey-mobile-menu__arrow" viewBox="0 0 8 13" aria-hidden="true" focusable="false"><path d="M1.25 1.25L6.5 6.5L1.25 11.75" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function mobileBackSvg() {
    return '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M12.5 4L6.5 10L12.5 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function sourceLinkIsVisible(link) {
    if (!link) return false;
    if (link.hidden) return false;
    const hiddenAncestor = link.closest('[hidden]');
    return !hiddenAncestor;
  }

  function usableSourceHref(link) {
    if (!link || link.tagName !== 'A') return '';
    const href = link.getAttribute('href') || '';
    if (!href || href === '#jersey-unmatched' || link.getAttribute('aria-disabled') === 'true') return '';
    return href;
  }

  function copyDirectMobileLink(sourceLink, extraClass = '') {
    const link = document.createElement('a');
    link.className = `jersey-mobile-menu__link${extraClass ? ` ${extraClass}` : ''}`;
    link.href = sourceLink.getAttribute('href') || '#';

    const label = document.createElement('span');
    label.textContent = labelForLink(sourceLink);
    link.appendChild(label);

    if (sourceLink.getAttribute('aria-current') === 'page' || sourceLink.classList.contains('is-current')) {
      link.classList.add('is-current');
      link.setAttribute('aria-current', 'page');
    }

    return link;
  }

  function createMobilePanel(id, title, parentId = '') {
    const panel = document.createElement('section');
    panel.className = 'jersey-mobile-panel';
    panel.dataset.mobilePanel = id;
    panel.setAttribute('aria-hidden', 'true');

    if (parentId) {
      const head = document.createElement('div');
      head.className = 'jersey-mobile-panel__head';

      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'jersey-mobile-panel__back';
      back.dataset.mobileBack = parentId;
      back.setAttribute('aria-label', 'Back');
      back.innerHTML = mobileBackSvg();

      const heading = document.createElement('div');
      heading.className = 'jersey-mobile-panel__title';
      heading.textContent = title;

      head.append(back, heading);
      panel.appendChild(head);
    }

    const list = document.createElement('ul');
    list.className = 'jersey-mobile-panel__list';
    list.setAttribute('role', 'list');
    panel.appendChild(list);

    return { panel, list };
  }

  function createMobilePanelButton(labelText, targetId) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jersey-mobile-menu__button';
    button.dataset.mobileOpenPanel = targetId;
    button.setAttribute('aria-expanded', 'false');

    const label = document.createElement('span');
    label.textContent = labelText;
    button.appendChild(label);
    button.insertAdjacentHTML('beforeend', mobileArrowSvg());
    return button;
  }

  function appendListItem(list, child) {
    const li = document.createElement('li');
    li.appendChild(child);
    list.appendChild(li);
  }

  function buildMobileMenu(container) {
    const mobile = container.querySelector('[data-jersey-mobile]');
    const mount = container.querySelector('[data-jersey-mobile-nav]');
    const sourceNav = container.querySelector('[data-jersey-nav]');
    const openButton = container.querySelector('[data-jersey-mobile-open]');
    if (!mobile || !mount || !sourceNav) {
      if (openButton) openButton.hidden = true;
      return;
    }

    mount.innerHTML = '';
    let panelCounter = 0;
    const nextPanelId = (prefix) => `${prefix}-${++panelCounter}`;
    const rootData = createMobilePanel('root', '');
    rootData.panel.classList.add('is-active');
    rootData.panel.setAttribute('aria-hidden', 'false');
    mount.appendChild(rootData.panel);

    const topItems = Array.from(sourceNav.querySelectorAll(':scope .jersey-nav__list > .jersey-nav__item'))
      .filter((item) => !item.hidden && !item.closest('[hidden]'));

    topItems.forEach((item) => {
      const trigger = directTopLink(item);
      if (!trigger || !sourceLinkIsVisible(trigger)) return;
      const topLabel = labelForLink(trigger);
      if (!topLabel) return;

      const mega = item.querySelector(':scope > .jersey-mega');
      const dropdown = item.querySelector(':scope > .jersey-dropdown');

      if (mega && !mega.hidden) {
        const secondId = nextPanelId('mobile-mega');
        appendListItem(rootData.list, createMobilePanelButton(topLabel, secondId));
        const secondData = createMobilePanel(secondId, topLabel, 'root');
        mount.appendChild(secondData.panel);

        const columns = Array.from(mega.querySelectorAll('.jersey-mega__column'))
          .filter((column) => !column.hidden && !column.closest('[hidden]'));

        columns.forEach((column) => {
          const heading = column.querySelector(':scope > .jersey-mega__heading');
          if (!heading || !sourceLinkIsVisible(heading)) return;
          const headingLabel = labelForLink(heading);
          if (!headingLabel) return;

          const childLinks = Array.from(column.querySelectorAll(':scope > .jersey-mega__links > li > .jersey-mega__link'))
            .filter(sourceLinkIsVisible);

          if (childLinks.length) {
            const thirdId = nextPanelId('mobile-group');
            appendListItem(secondData.list, createMobilePanelButton(headingLabel, thirdId));
            const thirdData = createMobilePanel(thirdId, headingLabel, secondId);
            mount.appendChild(thirdData.panel);

            const headingHref = usableSourceHref(heading);
            if (headingHref) {
              const viewAll = document.createElement('a');
              viewAll.className = 'jersey-mobile-menu__view-all';
              viewAll.href = headingHref;
              viewAll.textContent = `View all ${headingLabel}`;
              thirdData.panel.insertBefore(viewAll, thirdData.list);
            }

            childLinks.forEach((childLink) => {
              appendListItem(thirdData.list, copyDirectMobileLink(childLink));
            });
          } else {
            const href = usableSourceHref(heading);
            if (href) appendListItem(secondData.list, copyDirectMobileLink(heading));
          }
        });
      } else if (dropdown && !dropdown.hidden) {
        const secondId = nextPanelId('mobile-dropdown');
        appendListItem(rootData.list, createMobilePanelButton(topLabel, secondId));
        const secondData = createMobilePanel(secondId, topLabel, 'root');
        mount.appendChild(secondData.panel);

        Array.from(dropdown.querySelectorAll('.jersey-dropdown__link'))
          .filter(sourceLinkIsVisible)
          .forEach((childLink) => appendListItem(secondData.list, copyDirectMobileLink(childLink)));
      } else if (trigger.tagName === 'A' && usableSourceHref(trigger)) {
        appendListItem(rootData.list, copyDirectMobileLink(trigger));
      }
    });

    if (!rootData.list.children.length) {
      const empty = document.createElement('div');
      empty.className = 'jersey-mobile-menu__empty';
      empty.textContent = 'No menu items available.';
      rootData.panel.appendChild(empty);
      if (openButton) openButton.hidden = true;
    } else if (openButton) {
      openButton.hidden = false;
    }
  }

  function initMobileNav(container) {
    const mobile = container.querySelector('[data-jersey-mobile]');
    if (!mobile) return;

    buildMobileMenu(container);
    if (mobile.dataset.jerseyMobileBound === 'true') return;
    mobile.dataset.jerseyMobileBound = 'true';

    const openButton = mobile.querySelector('[data-jersey-mobile-open]');
    const drawer = mobile.querySelector('[data-jersey-mobile-drawer]');
    const navMount = mobile.querySelector('[data-jersey-mobile-nav]');
    if (!openButton || !drawer || !navMount) return;

    let lastFocused = null;

    const activatePanel = (id) => {
      navMount.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        const active = panel.dataset.mobilePanel === id;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) panel.scrollTop = 0;
      });
    };

    const openDrawer = () => {
      lastFocused = document.activeElement;
      activatePanel('root');
      mobile.classList.add('is-open');
      openButton.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jersey-mobile-menu-open');
      requestAnimationFrame(() => {
        const close = drawer.querySelector('.jersey-mobile-drawer__close');
        if (close) close.focus({ preventScroll: true });
      });
    };

    const closeDrawer = () => {
      mobile.classList.remove('is-open');
      openButton.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jersey-mobile-menu-open');
      activatePanel('root');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    };

    openButton.addEventListener('click', openDrawer);
    mobile.querySelectorAll('[data-jersey-mobile-close]').forEach((control) => {
      control.addEventListener('click', closeDrawer);
    });

    navMount.addEventListener('click', (event) => {
      const next = event.target.closest('[data-mobile-open-panel]');
      if (next) {
        event.preventDefault();
        activatePanel(next.dataset.mobileOpenPanel);
        return;
      }

      const back = event.target.closest('[data-mobile-back]');
      if (back) {
        event.preventDefault();
        activatePanel(back.dataset.mobileBack);
      }
    });

    mobile.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobile.classList.contains('is-open')) {
        event.preventDefault();
        closeDrawer();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990 && mobile.classList.contains('is-open')) closeDrawer();
    });
  }

  function containersFromRoot(root = document) {
    if (root.matches && root.matches('.jersey-header-shell')) return [root];
    if (root.querySelectorAll) return Array.from(root.querySelectorAll('.jersey-header-shell'));
    return [];
  }

  function boot(root = document) {
    // Prune the built-in menu first. Mobile is then generated from that exact
    // filtered desktop structure so both breakpoints always stay in sync.
    const containers = containersFromRoot(root);
    containers.forEach(manageReferenceMenu);
    containers.forEach(initMobileNav);
    initNav(root);
    initLocale(root);
    initSmartCollectionLinks(root);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-jersey-locale]')) {
      document.querySelectorAll('[data-jersey-locale][open]').forEach((details) => details.removeAttribute('open'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-jersey-locale][open]').forEach((details) => details.removeAttribute('open'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
